import {
    DialogActions,
    Dialog as MuiDialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Divider, Grid
} from "@mui/material";
import {Close} from "~/ui/icons";
import React, {useEffect} from "react";
import {useDialogStack} from "~/components/DialogStack";
import {DialogContentTextProps} from "@mui/material/DialogContentText/DialogContentText";


export type DialogProps = {
    open: boolean
    onClose?: () => void
    children?: any
    title?: any
    actions?: any
    dialogContentTextProps?: DialogContentTextProps,
    dialogPaperStyle?: string
    debug?: boolean
}


export const Dialog = (props: DialogProps) => {
    const {onClose, open: _open, title, children, actions, dialogContentTextProps, dialogPaperStyle } = props;
    const { state, setOpen } = useDialogStack(onClose, 0);
    const isLoaded = React.useRef(false);

    const handleClose = async () => {
        if (onClose) {
            await setOpen(false).then(() => onClose())
        }
    }

    useEffect(() => {
        if (isLoaded.current) {
            setOpen(_open);
        } else {
            isLoaded.current = true;
        }

    }, [_open])

    const closeButton = (
        <IconButton size="mini" onClick={handleClose} color="primary">
            <Close/>
        </IconButton>
    );

    return (
        <MuiDialog open={state == "visible"} onClose={handleClose} classes={{paper: dialogPaperStyle}}>
            {title && (
                <>
                    <DialogTitle>
                        <Grid container wrap="nowrap">
                            <Grid item flexGrow={1} zeroMinWidth>
                                {title}
                            </Grid>
                            <Grid item flexShrink={0} zeroMinWidth>
                                {closeButton}
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider/>
                </>
            )}
            <DialogContent>
                <DialogContentText variant="screenText" {...dialogContentTextProps}>
                    {!title && (
                        <span style={{float: "right", clear: "both"}}>
                            {closeButton}
                        </span>
                    )}
                    {children}
                </DialogContentText>
            </DialogContent>
            {actions && (
                <DialogActions>
                    {actions}
                </DialogActions>
            )}
        </MuiDialog>
    )
}
